import type { TFunction } from 'i18next';
import type { DeepRequired, FieldErrorsImpl } from 'react-hook-form';
import type { FormFields } from './schema';
import { z } from 'zod';
import { applySchema } from './schema';

export const calculateProgress = (values: Partial<FormFields>, errors: Partial<FieldErrorsImpl<DeepRequired<FormFields>>>, t: TFunction) => {
    const schemaFields = Object.keys(applySchema(t).shape) as (keyof FormFields)[];
    const totalFields = schemaFields.length;

    let filledFields: number = 0;

    schemaFields.forEach((key) => {
        const fieldValue = values[key];
        const fieldSchema = applySchema(t).shape[key];
        const fieldError = errors[key];

        // eslint-disable-next-line ts/switch-exhaustiveness-check
        switch (true) {
            case (fieldSchema instanceof z.ZodBoolean && fieldValue !== undefined && fieldValue !== null && !fieldError):
            case (fieldSchema instanceof z.ZodLiteral && fieldValue === true && !fieldError):
            case (fieldSchema instanceof z.ZodNumber && typeof fieldValue === 'number' && !Number.isNaN(fieldValue) && !fieldError):
            case (fieldSchema instanceof z.ZodString && typeof fieldValue === 'string' && !!fieldValue.trim() && !fieldError):
                filledFields++;
                break;
        }
    });

    return Math.round((filledFields / totalFields) * 100);
};
